import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { actionUrl } from 'config/static-content';
import { NsAlert } from 'components/common/ns-alert/NsAlert';

export const testId = 'agentScriptingInfoTestId';

type Props = {
  shouldShow?: boolean;
};

export const AgentScriptingInfo = ({ shouldShow }: Props) => {
  if (!shouldShow) {
    return null;
  }

  return (
    <NsAlert state="info" heading="Read the following" testId={testId}>
      <p>
        The Priority Services Register is a free support service that is
        available to some of our customers who may need it. It means you will be
        treated as a priority in the event of loss of supply, or a power outage.
        Sometimes we&apos;ll share your data with those who supply and maintain
        the supply of Electricity & Gas to your home, including meter operators,
        engineering partners, network operators and your water supplier.
        <br />
        <br />
        When you sign up to the Priority Services Register, we’ll store and
        manage your data on our secure systems. You can read more about how we
        use your information above in Energy privacy notice at{' '}
        <NsAnchor href={actionUrl.privacy}>
          britishgas.co.uk/privacy-policy
        </NsAnchor>
        <br />
        <br />
        Sometimes we&apos;ll share your data with those who supply and maintain
        the supply of Electricity & Gas to your home, including meter operators,
        engineering partners, network operators and your water supplier.
      </p>
    </NsAlert>
  );
};
